import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { errorActions } from '../store/actions';
const useForm = (callback, validate, handleStateChange, state) => {
              

  const dispatch = useDispatch();
  const errors = useSelector(state => state.validationErrors)

  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [someArgument, setSomeArgument] = useState("");

  useEffect(() => {
    setIsSubmitting(false)
    if (Object.keys(errors).length === 0 && isSubmitting) { 
      callback(someArgument); 
    }
  }, [errors]); 

  useEffect(() => {
    if (isSubmitting) dispatch(errorActions.setValidationErrors(validate(state)));
  }, [isSubmitting]);                                         

  const handleSubmit = (argument = "") => {
    setIsSubmitting(true); 
    if (argument) setSomeArgument(argument)

  };

  const handleChange = (...args) => {
    dispatch(errorActions.resetValidationErrors())
    setIsSubmitting(false);
    handleStateChange(...args)  
  };

  return {
    handleChange,
    handleSubmit,
  }
};

export default useForm;